<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Add Customer</span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
    </div>
    <div class="ttmodal__body">
        <!--<span class="input-description" *ngIf="userAccessType < 1">Please select the dealer group this customer belongs to. </span>
        <div class="input-container" *ngIf="userAccessType < 1">
            <span class="label">Dealer Group
                <span class="red-text">*</span>
            </span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">location_city</i>
            </span>
            <select [(ngModel)]="selectedDealerGroupId" (change)="dealerGroupSelected($event.target.value)" required>
                <option value="" disabled selected>Select Dealer Group</option>
                <option *ngFor="let dealergroup of dealergroups" [value]="dealergroup.Id">{{dealergroup.Name}}</option>
            </select>
        </div>-->
        <span class="input-description" *ngIf="(userAccessType >= 1) && (userAccessType <= 3)">Please select the dealer this customer belongs to. </span>
        <div class="input-container" *ngIf="(userAccessType >= 1) && (userAccessType <= 3)">
            <span class="label">Dealer
                <span class="red-text">*</span>
            </span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">location_city</i>
            </span>
             <select [(ngModel)]="selectedDealershipId" (change)="dealerSelected($event.target.value)" required class="get-select-text">
                <option value="0" disabled selected>Select Dealer</option>
                <option *ngFor="let dealership of dealerships" [value]="dealership.DealershipId">{{dealership.DealershipName}}</option>
            </select>
            
        </div>
        <span class="input-description">Tell us some basic details about the customer.</span>
        

        <div class="input-container">
            <span class="label">Customer Name <span class="red-text">*</span></span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">supervisor_account</i>
            </span>
            <input [(ngModel)]="customerName" type="text" placeholder="Mining Corp" (blur)="validateCustomerName()" required>
        </div>
        <!-- TT-9118 -->
        <!-- <div style="color: red;" *ngIf="!customerNameValid">{{'A Customer with this name already exists in your Dealer Group. Please contact your Dealer group administrator to be given access to this customer'}}</div> -->
        <div style="color: red;" *ngIf="!customerNameValid">{{'A Customer with this name already exists - please can you add more details for the customer, or contact your administrator if you feel this is in error.'}}</div>
       
        <div *ngIf="showAll==false" style="display: flex;flex-direction: row;justify-content: center;">
            <i class="material-icons" (click)="ShowAllFields()">arrow_circle_down</i>
            <span style=" align-self: center;">Click here for more fields if required</span>
        </div>
        
        <div *ngIf="isBasicUser==1 || showAll==true">

       
        <div class="input-container">
            <span class="label">Customer Reference </span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">pending_actions</i>
            </span>
            <input [(ngModel)]="customerReference" type="text" placeholder="Reference" >
        </div>
        
        <div class="input-container">
            <span class="label">Phone Number</span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">phone</i>
            </span>
            <input [(ngModel)]="phoneNumber" type="text" placeholder="61400000000">
        </div>
        <div class="input-container">
            <span class="label">Email</span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">email</i>
            </span>
            <input [(ngModel)]="email" type="text" placeholder="example@miningco.com">
        </div>
        <div class="input-container">
            <span class="label">Address</span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">location_on</i>
            </span>
            <input [(ngModel)]="address" type="text" placeholder="100 Example Street, Melbourne, Australia" #search [formControl]="searchControl">
        </div>

        <div class="input-container">
            <span class="label">Default Hourly Labour Cost</span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">attach_money</i>
            </span>
            <input placeholder="20.00" type="number" step="0.01" [(ngModel)]="hourlyRate" class="get-select-text">
            <!-- [formControl] = "hourlyRateFormControl"  -->
            <!-- <div class="form-control-feedback" *ngIf="hourlyRateFormControl.errors && (hourlyRateFormControl.dirty || hourlyRateFormControl.touched)">
                <p *ngIf="hourlyRateFormControl.errors.required">Hourly Labour Cost is required</p>
                <p *ngIf="hourlyRateFormControl.errors.pattern"> Only 2 decimal places Allowed </p>
            </div> -->
        </div>

        <div *ngIf="themorgraphyEnabled" class="input-container">
            <span class="label">Thermography Enabled</span>
            <mat-radio-group  [(ngModel)]="rdThemorgrphyEnable" name="rdThemorgrphyEnable">
                <mat-radio-button [value]="1">Yes</mat-radio-button>
                <mat-radio-button [value]="2">No</mat-radio-button>
              </mat-radio-group>
        </div>
        <div class="input-container">
            <span class="label">Repairer</span>
            <mat-checkbox [(ngModel)]="isRepairer"></mat-checkbox>
        </div>


        <span class="input-description">Please select a style for this customers reports. </span>
        <div class="input-container">
            <span class="label">Condition Report Style
                <span class="red-text">*</span>
            </span>
            <select [(ngModel)]="selectedReportStyleId" required class="get-select-text">
                <option value="0" disabled selected>Select Report Style</option>
                <option *ngFor="let reportStyle of reportStyles" [value]="reportStyle.ReportId">{{reportStyle.ReportName}}</option>
            </select>
        </div>

        <span class="input-description">Please select a style for this customers rope shovel reports. </span>
        <div class="input-container">
            <span class="label">Rope Shovel Report Style
                <span class="red-text">*</span>
            </span>
            <select [(ngModel)]="ropeselectedReportStyleId" required class="get-select-text">
                <option value="0" disabled selected>Select Report Style</option>
                <option *ngFor="let reportStyle of ropereportStyles" [value]="reportStyle.ReportId">{{reportStyle.ReportName}}</option>
            </select>
        </div>

        <!-- <span class="input-description">Please select a style for this customers GET wear surface reports. </span>
        <div class="input-container">
            <span class="label">GET Wear Surface Report Style
                <span class="red-text">*</span>
            </span>
            <select [(ngModel)]="wearselectedReportStyleId" required class="get-select-text">
                <option value="0" disabled selected>Select Report Style</option>
                <option *ngFor="let reportStyle of wearreportStyles" [value]="reportStyle.ReportId">{{reportStyle.ReportName}}</option>
            </select>
        </div> -->

        <span class="input-description">Please select a style for this customers Undercarriage Rebuild Centre reports. </span>
        <div class="input-container">
            <span class="label">URC Report Style
                <span class="red-text"></span>
            </span>
            <select [(ngModel)]="wsreselectedReportStyleId" required class="get-select-text">
                <option value="0" disabled selected>Select Report Style</option>
                <option *ngFor="let reportStyle of wsrereportStyles" [value]="reportStyle.ReportId">{{reportStyle.ReportName}}</option>
            </select>
        </div>

    
        <span class="input-description">Please select a quote report style for this customers. </span>
        <div class="input-container">
            <span class="label">Quote Report Style
                <!-- <span class="red-text">*</span> -->
            </span>
            <select [(ngModel)]="selectedQuoteReportStyleId" class="get-select-text" >
                <option value="0" disabled selected>Select Report Style</option>
                <option *ngFor="let reportStyle of quoteReportStyles" [value]="reportStyle.ReportId">{{reportStyle.ReportName}}</option>
            </select>
        </div>

        <span class="input-description">Upload a logo for the customer. Recommended 77px by 35px.</span>
        <input type='file' (change)="onSelectImage($event)">
        <div style="margin-top: 8px;">
            <img *ngIf="imageUrl" [src]="imageUrl" height="70" width="154">
        </div>
        </div>
    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onNoClick()">
            <span class="button__text">Cancel</span>
        </a>
        <button class="button button--primary" (click)="addNewCustomer()" [class.loading]="savingNewCustomer" [disabled]="!customerNameValid">
            <span class="button__text">Add Customer</span>
        </button>
    </div>
</div>
